(function() {
  'use strict';

  function SetupAppService(SetupService) {
    var service = this;

    service.setupApp = function() {
      return SetupService.setupApp();
    };

    service.initApp = function() {
      return SetupService.initApp();
    };

    service.getSetupStatus = function() {
      return SetupService.getSetupStatus();
    };
  }

  SetupAppService.$inject = ['SetupService'];

  angular.module('blocks.setup')
  .service('SetupAppService', SetupAppService);
})();
